// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1iDAj","item":"PaymentsMobile_item__thKYk","label":"PaymentsMobile_label__3_OqI","amount":"PaymentsMobile_amount__3Vho6"};